export default __webpack_public_path__ + "static/media/cloud2.eb0aec6a.svg";